// extracted by mini-css-extract-plugin
export default {"myFooter":"Footer_myFooter__QVHSq","icon":"Footer_icon__aHB8J","facebook":"Footer_facebook__Ob4lL","instagram":"Footer_instagram__hIayL","viber":"Footer_viber__GnYDL"};